<div class="container content-wrapper pt-5 " style="margin-top:2rem;">
    <div class="row">
        <div class="col-md-12">
            <div class="card text-center border-warning mx-auto" >
                <h5 class="card-header border-warning">Payment Status</h5>
                <div *ngIf="freshpayment">
                <div  *ngIf="paymentSuccess"class="card-body text-success">
                    <div>
                        <img src="./assets/img/checkmarksuccess.gif" class="correctimgclass">
                        <h5 class="card-title">Payment Successful</h5>
                        <p class="card-text">{{resmsg1}}</p>
                        <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
                    </div>
                 </div>
                 <div *ngIf="!paymentSuccess" class="card-body text-danger">  
                    <div >
                        <img src="./assets/img/alertmark.gif" class="errorimgclass">
                        <h5 class="card-title">Payment Unsuccessfull</h5>
                        <p class="card-text">{{resmsg}}</p>
                        <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="proccessing" class="loadingcont">
    <div class="spinner"></div>
  </div>
